import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, FormSection, change as formChange } from 'redux-form';
import { forEach, isEmpty } from 'lodash';
import { withTranslation } from 'react-i18next';
import { CLIENT_CSV_FORMATS_LIST } from 'src/constants/EndpointUrls';
import { CSV_FORMAT_TYPES } from 'src/constants/Options';
import { CLIENT_CSV_FORMAT_FORM } from 'src/constants/FormNames';
import Button from 'jbc-front/components/Button';
import { Section, TextField, RadioField } from 'src/jbc-front/components/Form';
import SelectLeftRightItems from './SelectLeftRightItems';
import SelectGroupItems from './SelectGroupItems';
import styles from './ClientCsvFormatForm.scss';

const addUuidToItems = csvAvaiableItems => {
  const result = {};
  let offset = 1; // Avoid 0 here, because 0 == false in JS :(
  forEach(csvAvaiableItems, (groupItems, groupName) => {
    result[groupName] = {};
    forEach(groupItems, (items, label) => {
      result[groupName][label] = items.map((item, itemIndex) => ({ ...item, uuid: itemIndex + offset }));
      offset += items.length;
    });
  });

  return result;
};

const findUuidByAttrs = (item, hashItems) => {
  let uuid;

  forEach(hashItems, groupItems => {
    forEach(groupItems, items => {
      const found = items.find(
        i => i.applyFor === item.applyFor && i.group === item.group && i.id === item.id && i.kind === item.kind && i.label === item.label
      );
      if (found) {
        uuid = found.uuid;
        return false;
      }
      return true;
    });
  });

  return uuid;
};

const mapUuidToItems = (itemsWithUUid, itemsNoUuid) => {
  if (isEmpty(itemsWithUUid)) return [];
  return itemsNoUuid.map(item => ({ ...item, uuid: findUuidByAttrs(item, itemsWithUUid) }));
};

class ClientCsvFormatForm extends React.Component {
  constructor(props) {
    super(props);
    const { clientCsvData } = this.props;

    this.state = {
      selectingLeftItems: [],
      rightItems: clientCsvData.currentSelectedFields,
      selectingRightItems: [],
      selectingGroups: clientCsvData.currentSelectedGroups
    };
  }

  setStateData = newData => {
    this.dispatchFormValue(newData);
    this.setState(prevState => ({ ...prevState, ...newData }));
  };

  addPosition = items => [...items.map((item, index) => ({ ...item, position: index }))];

  dispatchFormValue = data => {
    if (Object.keys(data).includes('rightItems')) {
      this.props.dispatch(formChange(CLIENT_CSV_FORMAT_FORM, 'clientCsvFormatFields', this.addPosition(data.rightItems)));
    }
    if (Object.keys(data).includes('selectingGroups')) {
      this.props.dispatch(formChange(CLIENT_CSV_FORMAT_FORM, 'clientCsvFormatGroups', [...data.selectingGroups]));
    }
  };

  render() {
    const { isCreateForm, formatType, csvAvaiableItems, allGroups, submitting, submit, pristine, handleSubmit, goBackPath } = this.props;
    const { selectingLeftItems, selectingRightItems, selectingGroups } = this.state;

    let { rightItems } = this.state;

    /*
     * All items are merged from varying tables,
     * so we add unique id to each item to ensure no item has same id
     * and use this uuid to discriminate from others
     */
    const csvAvaiableItemsWithUuid = addUuidToItems(csvAvaiableItems);
    rightItems = mapUuidToItems(csvAvaiableItemsWithUuid, rightItems);

    const leftItems =
      formatType === 'bonus'
        ? { ...csvAvaiableItemsWithUuid[formatType] }
        : { ...csvAvaiableItemsWithUuid.attendance, ...csvAvaiableItemsWithUuid[formatType] };

    return (
      <form onSubmit={handleSubmit}>
        <Section title={this.props.t(`features.ClientCsvFormats.components.ClientCsvFormatsTable.${isCreateForm ? 'create' : 'edit'}_format`)}>
          <FormSection name="clientCsvFormat">
            <RadioField
              name="formatType"
              label={this.props.t('features.ClientCsvFormats.components.ClientCsvFormatsTable.format_type')}
              options={CSV_FORMAT_TYPES}
              required
            />
            <TextField name="label" label={this.props.t('features.ClientCsvFormats.components.ClientCsvFormatsTable.format_name')} required />
          </FormSection>

          <FormSection name="clientCsvFormatFields">
            <SelectLeftRightItems {...{ leftItems, selectingLeftItems, rightItems, selectingRightItems }} changeParentState={this.setStateData} />
          </FormSection>

          <FormSection name="clientCsvFormatGroups">
            <SelectGroupItems {...{ allGroups, selectingGroups }} changeParentState={this.setStateData} />
          </FormSection>

          <div className={styles.actionButtons}>
            <span>
              <Button as="a" href={goBackPath || CLIENT_CSV_FORMATS_LIST}>
                {this.props.t('components.BonusFormModal.Cancel')}
              </Button>
            </span>
            <span>
              <Button primary onClick={submit} disabled={submitting || pristine}>
                {this.props.t('components.BonusFormModal.Save')}
              </Button>
            </span>
          </div>
        </Section>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  formatType: getFormValues(CLIENT_CSV_FORMAT_FORM)(state).clientCsvFormat.formatType
});

export default withTranslation('translation')(connect(mapStateToProps)(ClientCsvFormatForm));
